import { z } from 'zod';

export const CustomerTierSchema = z.enum(['KEY', 'GROWTH', 'LONGTAIL']);
export type CustomerTier = z.infer<typeof CustomerTierSchema>;

export const ProductGroupSchema = z.enum([
  'COSMETIC',
  'FMCG',
  'ELECTRONICS',
  'APPAREL',
  'OTHER',
]);
export type ProductGroup = z.infer<typeof ProductGroupSchema>;

export const ChannelSchema = z.enum(['SHOPEE', 'LAZADA', 'TIKTOK', 'WEBSITE', 'B2B', 'OTHER']);
export type Channel = z.infer<typeof ChannelSchema>;

export const ProductMixEntrySchema = z.object({
  product_group: ProductGroupSchema,
  share: z.number().min(0).max(1), // 0..1, sum to 1
});
export type ProductMixEntry = z.infer<typeof ProductMixEntrySchema>;

export const CustomerSchema = z.object({
  id: z.string(),
  code: z.string().min(1), // LOREAL-VN
  name: z.string().min(1), // L'Oréal Vietnam
  tier: CustomerTierSchema,
  primary_warehouse_id: z.string(),
  product_mix: z.array(ProductMixEntrySchema).default([]),
  channels: z.array(ChannelSchema).default([]),
  is_active: z.boolean().default(true),
  created_at: z.string(),
});
export type Customer = z.infer<typeof CustomerSchema>;
